import React  from 'react';

const FOOTER_SRC = 'https://www.servicepostal.com/footer/';
window.addEventListener('message', (e) => { if (e.data.sp) document.querySelector('#footer').style.height = e.data.sp + 'px' })

class Footer extends React.Component {
  
  constructor() {
      super();
      this.state = {};
    }

    render() {
      return (
        <iframe id="footer" src={ FOOTER_SRC } title="Site footer"
                style={{ border: 0, padding: 0, margin: 0, width: '100%', minHeight: '10rem', overflow: 'hidden' }}>
        </iframe>
      );
    }
}



export default Footer;
